import React from "react";

import BaseUpdateCard, { type CardStatus } from "./BaseCard";

type Props = {
  status: CardStatus;
};

function InstallingCard({ status }: Props): React.JSX.Element {
  return (
    <BaseUpdateCard
      status={status}
      title={"Installing app"}
      subtitle={"Installing new features"}
      iconName={"arrow-undo-circle"}
    />
  );
}

export default InstallingCard;
